export default "__VITE_ASSET__e64e10d8__"